export default [{
        path: '/roles',
        name: 'roles',
        component: () =>
            import ('@/views/pages/roles/roles-list/RolesList.vue'),
        meta: {
            pageTitle: 'Roles',
            breadcrumb: [{
                text: 'Roles',
                active: true,
            }, ],
            resource: 'rol',
            action: 'read',
        },
    },
    {
        path: '/roles/view/:id',
        name: 'roles-view',
        component: () =>
            import ('@/views/pages/roles/roles-view/RolView.vue'),
        meta: {
            pageTitle: 'View Role',
            breadcrumb: [
            {
                text: 'Roles',
                to: '/roles',
            },{
                text: 'View',
                active: true,
            }],
            resource: 'rol',
            action: 'read',
        },
    },
    {
        path: '/roles/edit/:id',
        name: 'roles-edit',
        component: () =>
            import ('@/views/pages/roles/roles-edit/RolesEdit.vue'),
        meta: {
            pageTitle: 'Edit Role',
            breadcrumb: [{
                text: 'Roles',
                to:'/roles',
            },
            {
                text: 'Edit',
                active: true,
            } ],
            resource: 'rol',
            action: 'read',
        },
    },
]